var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172.606,
    height: 53.132,
    viewBox: "0 0 172.606 53.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 172.606,
    height: 53.132,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M0,0V53.132H146.04V51.678H1.455V1.455H18.186V0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M90.73,0V1.455H235.315V51.678H218.583v1.455H236.77V0Z",
    transform: "translate(-64.164 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 3.232,
    height: 16.76,
    transform: "translate(18.186 18.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M93.592,61.7h2.274L105.2,72.621V61.7h3.232v16.76h-2.275L96.824,67.546V78.464H93.592Z",
    transform: "translate(-66.188 -43.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M167.964,64.577v3.472h5.148v2.873h-5.148v7.542h-3.232V61.7h10.056v2.873Z",
    transform: "translate(-116.498 -43.636)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 3.232,
    height: 16.76,
    transform: "translate(62.839 18.067)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 3.232,
    height: 16.76,
    transform: "translate(92.887 18.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M356.308,61.7v2.873h-4.429V78.464h-3.233V64.577h-4.429V61.7Z",
    transform: "translate(-243.429 -43.637)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M403.2,76.98a7.017,7.017,0,0,1-2.155-5.579V61.7h3.232V71.64a3.937,3.937,0,0,0,1.1,3.113,4.306,4.306,0,0,0,5.7,0,3.937,3.937,0,0,0,1.1-3.113V61.7h3.232v9.7a7.017,7.017,0,0,1-2.155,5.579,8.195,8.195,0,0,1-10.056,0",
    transform: "translate(-283.619 -43.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M478.523,71.736,484.629,61.7H486.9v16.76h-3.232V69.126l-4.022,6.584H477.4l-4.022-6.584v9.338h-3.232V61.7h2.275Z",
    transform: "translate(-332.483 -43.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M257.132,94.667v4.665l4.179-6.032-1.786-2.088Z",
    transform: "translate(-181.843 -64.506)",
    fill: "#009da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M275.658,61.7l-4.179,6.032,1.786,2.088,2.393-3.454L278.89,61.7Z",
    transform: "translate(-191.989 -43.637)",
    fill: "#009da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M257.705,66.369v6.253L248.367,61.7h-2.274v16.76h3.232V67.546l9.338,10.918h2.275V61.7Z",
    transform: "translate(-174.036 -43.637)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3533328aaaba17d0eb1f3c9e8653a084.svg";
export { ForwardRef as ReactComponent };